import config from "../../../../../config";
import Header from "../../../../../components/Header";
import Footer from "../../../../../components/Footer";
import Head from "next/head";

import VideoCardSmallCollection from "../../../../../components/VideoCardSmallCollection";
import HeaderExtension from "../../../../../components/HeaderExtension";

import pLimit from "p-limit";

function List({ projects, year, week, years, weeks }) {
  console.log("building", year, week);
  if (!year) return null;
  if (!week) return null;
  if (!projects) return null;

  return (
    <div className="bg-gray-100  absolute w-full min-h-screen">
      <Head>
        <title>
          Automate.video | Directory {year} week {week}{" "}
        </title>
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Header />
      <HeaderExtension title={`Videos from week ${week} in ${year}`} />
      <div className="container relative px-2 mx-auto mt-24 mb-24 w-full min-h-screen">
        <VideoCardSmallCollection projects={projects} />
        <div className="flex flex-row w-full items-center  ">
          {years.map((y) => {
            return (
              <div key={y} className=" w-full ">
                <h3 style={{ color: "#8892a8" }} className="w-full justify-start text-2xl  font-bold  mt-1  mb-3  ">
                  {y}
                </h3>
                <span className="mr-2">Week:</span>{" "}
                {weeks.map((w) => {
                  if (w.year_cat === y)
                    return (
                      <a key={y + w.week_cat} href={`/directory/year/${y}/week/${w.week_cat}`} className="mr-2">
                        {w.week_cat}
                      </a>
                    );
                  else return null;
                })}
              </div>
            );
          })}
        </div>
      </div>

      <Footer />
    </div>
  );
}

export async function getStaticPaths() {
  // Call an external API endpoint to get posts
  const res = await fetch(`${config.socketIo}/api/getPublicProjectsWeeklyCategories`);

  const posts = await res.json();

  // just prerender the last 10 weeks to speed up deployment
  // const modifiedPosts = posts.slice(Math.max(posts.length - 10, 0));

  // Get the paths we want to pre-render based on posts

  // const paths = posts.map((post) => `/directory/year/${post.year_cat}/week/${post.week_cat}`);
  // pre-render only latest week
  const paths = [`/directory/year/${posts[0].year_cat}/week/${posts[0].week_cat}`];

  // We'll pre-render only these paths at build time.
  // { fallback: false } means other routes should 404.
  return { paths, fallback: true };
}

export async function getStaticProps({ params }) {
  const delay = require("delay");
  // params contains the post `id`.
  // If the route is like /posts/1, then params.id is 1
  let year = params.year;
  let week = params.week;
  if (!year) return null;
  if (!week) return null;

  console.log(params);
  const res = await fetch(`${config.socketIo}/api/getPublicProjectsByWeek`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ year: year, week: week }),
  });

  if (res.status === 404) return { props: { projects: null } };
  const data = await res.json();

  async function createProjectsObj(d) {
    let width = 200;
    let height = 111;
    let playIcon = true;
    // this logic + calling the whole getVideoThumbnail should be a library logic, now replicate from here everywhere needed
    // create thumbnail filename, attribute name
    let thumbnailName = "thumbnail_w" + width + "h" + height + (playIcon ? "pT" : "pF");

    // check if thumbnail previously created, if yes, use overwrite
    let previewImageUrl = null;
    if (d.urls?.[thumbnailName]) previewImageUrl = d.urls[thumbnailName];

    if (!previewImageUrl) {
      const thumbnailres = await fetch(
        config.mediacache + "/api/cache-getVideoThumbnail?mode=url&width=200&height=111&projectid=" + d.projectid,
        {
          retryOn: [502, 503],
          retries: 7,
          retryDelay: 1000,
        }
      );

      try {
        const thumbnailjson = await thumbnailres.json();
        previewImageUrl = thumbnailjson.url;
      } catch (err) {
        console.warn("did not get videoThumbnail for " + d.projectid + ", status" + thumbnailres?.status);
        return {
          projectid: d.projectid,
          projectUrl: "/" + d.projectid,
          name: d.name,
          previewImageUrl: null,
          created: d.created,
        };
      }
    }
    return {
      projectid: d.projectid,
      projectUrl: "/" + d.projectid,
      name: d.name,
      previewImageUrl: previewImageUrl,
      created: d.created,
    };
  }

  // Example Concurrency of 3 promise at once
  const limit = pLimit(20);

  // create promises
  let projectPromises = data.map((d) => {
    // use limit function defined above
    return limit(() => createProjectsObj(d));
  });

  // wait for promises to run in batches
  const projects = await Promise.all(projectPromises);
  /*
  let projects = [];
  for await (let d of data) {
    await delay(20);
    const thumbnailres = await fetch(
      config.mediacache + "/api/cache-getVideoThumbnail?mode=url&width=200&height=111&projectid=" + d.projectid,
      {
        retryOn: [502, 503],
        retries: 7,
        retryDelay: 1000,
      }
    );
    let previewImageUrl = null;
    try {
      const thumbnailjson = await thumbnailres.json();
      previewImageUrl = thumbnailjson.url;
    } catch (err) {
      console.warn(err);
      console.warn(thumbnailres);
      console.warn("did not get videoThumbnail for " + d.projectid);
      throw new Error(err);
    }

    // config.mediacache + "/api/cache-getVideoThumbnail?width=200&height=111&projectid=" + d.projectid;
    projects.push({
      projectid: d.projectid,
      projectUrl: "/" + d.projectid,
      name: d.name,
      previewImageUrl: previewImageUrl,
      created: d.created,
    });
  } */

  const res2 = await fetch(`${config.socketIo}/api/getPublicProjectsWeeklyCategories`);

  const weeks = await res2.json();
  let years = [];
  for (let d of weeks) if (years.indexOf(d.year_cat) === -1) years.push(d.year_cat);

  return { props: { projects, year: params.year, week: params.week, years: years, weeks: weeks }, revalidate: 600 };
}

export default List;
